const ArrowDown = () => (
  <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
    <path d="M5.83334 8.33337L10 12.5L14.1667 8.33337H5.83334Z" fill="white" />
  </svg>
);

export default ArrowDown;
